import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import { lojaRoutes } from './loja-routes'
import { unidadeRoutes } from './unidade-routes'

import Home from '../pages/Home'
import AcompanharPedido from '../pages/AcompanharPedido'
import Ajuda from '../../../pages/Ajuda'
import ExcluirConta from '../../../pages/ExcluirConta'
import NotFound from '../../../pages/NotFound'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { page: 'Home' }
    },
    {
      path: '/home',
      redirect: '/'
    },

    ...lojaRoutes,

    ...unidadeRoutes,

    {
      path: '/ajuda',
      name: 'Ajuda',
      component: Ajuda,
      meta: { page: 'Ajuda', title: 'Ajuda' }
    },
    {
      path: '/excluir-conta',
      name: 'ExcluirConta',
      component: ExcluirConta,
      meta: { page: 'ExcluirConta', title: 'Excluir Conta' }
    },
    {
      path: '/acompanhar/:pedido',
      name: 'Acompanhar',
      component: AcompanharPedido,
      meta: { page: 'Acompanhar', title: 'Acompanhar Pedido' }
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
      meta: { page: 'NotFound', title: 'Página não Encontrada' }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  try {
    const dominio = store.state.empresa.dominio_delivery || '';
    const isFranquia = store.state.isFranquia;

    // Sempre permitir essas rotas
    if (['NotFound','Ajuda', 'ExcluirConta'].includes(to.name)) {
      return next();
    }

    if (!dominio) {
      return next(true);
    }

    if (isFranquia && dominio !== to.params.id && to.name !== 'Home') {
      return next('/');
    }

    if (!isFranquia && to.path.startsWith('/unidade')) {
      return next({ path: '/404', replace: true });
    }

    next();

  } catch (err) {
    next(false)
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    let pageTitle = router.app?.envEmpresa?.nome_fantasia || null;

    if (pageTitle) {
      pageTitle = (to.meta && to.meta.title) ? `${pageTitle} | ${to.meta.title}` : pageTitle
      document.title = pageTitle;
    }

    // Se GA não existir
    if (typeof window.gtag !== "function") return;

    window.dataLayer = window.dataLayer || [];

    window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: to.fullPath,
      page_title: pageTitle || document.title
    });
  });
});

export default router;